import React from "react";
import { Text } from "@hangar/web-components/core/Text";
import { useAppConfig } from "../../hooks/config/useAppConfig";
import {
  Container,
  ErrorContainer,
  LoadingContainer,
  NoConfigContainer,
} from "./ConfigInfo.styles";

/**
 * Componente para mostrar información de configuración
 * Útil para debugging y verificar que la configuración se carga correctamente
 */
export const ConfigInfo: React.FC = () => {
  const { config, loading, error } = useAppConfig();

  if (loading) {
    return (
      <LoadingContainer>
        <Text variant="body-sm">Loading configuration...</Text>
      </LoadingContainer>
    );
  }

  if (error) {
    return (
      <ErrorContainer>
        <Text variant="heading-sm">Configuration Error</Text>
        <Text variant="body-sm">{error.message}</Text>
      </ErrorContainer>
    );
  }

  if (!config) {
    return (
      <NoConfigContainer>
        <Text variant="body-sm">No configuration loaded</Text>
      </NoConfigContainer>
    );
  }

  return (
    <Container>
      <Text variant="heading-sm">Application Configuration</Text>
      <div>
        <Text variant="body-sm">
          Environment: <Text bold>{config.environment}</Text>
        </Text>
      </div>
      <div>
        <Text variant="body-sm">
          Client ID: <Text bold>{config.auth.clientId.substring(0, 8)}...</Text>
        </Text>
      </div>
      <div>
        <Text variant="body-sm">
          Authority: <Text bold>{config.auth.authority}</Text>
        </Text>
      </div>
      <div>
        <Text variant="body-sm">
          Redirect URI: <Text bold>{config.auth.redirectUri}</Text>
        </Text>
      </div>
    </Container>
  );
};
